import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchAdminFiberCocModels } from '@/api/(admin)/fiber-coc-models';
import type { AdminFiberCocModel } from '@/api/(admin)/fiber-coc-models/types';
import type { FiberCocModelsQueryInput } from '../-types';
import {
  buildFiberCocModelsQs,
  toFiberCocModelsParams,
} from '../-utils/listParams';

/** Prefix for every cache entry — what a write invalidates. */
export const fiberCocModelsQueryKey = ['admin', 'fiber-coc-models'] as const;

/** Shared by the route loader and the page, so the prefetch warms what the page reads. */
export function fiberCocModelsQueryOptions(input: FiberCocModelsQueryInput) {
  const params = toFiberCocModelsParams(input);
  return queryOptions({
    queryKey: [...fiberCocModelsQueryKey, 'list', params] as const,
    queryFn: () => fetchAdminFiberCocModels(buildFiberCocModelsQs(params)),
  });
}

export function useAdminFiberCocModels(input: FiberCocModelsQueryInput) {
  const query = useQuery(fiberCocModelsQueryOptions(input));
  const rows: AdminFiberCocModel[] = query.data?.data ?? [];
  return {
    rows,
    totalCount: query.data?.metadata?.pagination?.total ?? 0,
    isLoading: query.isLoading,
    isError: query.isError,
  };
}
